import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useEffect } from 'react';
import { clearSurfaces, closeSurface } from '../../../redux/awaitedSurfacesSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { AwaitedModals } from './awaitedSurfaces.entity';
import { useLocation } from 'react-router-dom';
var AwaitedSurfaces = function () {
    var location = useLocation();
    var dispatch = useAppDispatch();
    var modals = useAppSelector(function (state) { return state.modal.modals; });
    var handleResolve = useCallback(function (data) {
        dispatch(closeSurface(data));
    }, []);
    useEffect(function () {
        dispatch(clearSurfaces());
    }, [location.pathname]);
    return modals === null || modals === void 0 ? void 0 : modals.map(function (_ref) {
        var type = _ref.type, id = _ref.id, containerProps = _ref.containerProps, Component = _ref.Component, componentProps = _ref.componentProps;
        var Container = AwaitedModals[type];
        return /*#__PURE__*/ React.createElement(Container, _extends({
            key: id,
            open: true,
            onClose: function () { return handleResolve(); }
        }, containerProps), /*#__PURE__*/ React.createElement(Component, _extends({}, componentProps, {
            onClose: handleResolve
        })));
    });
};
export default AwaitedSurfaces;
